import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  onClick, 
  type = 'primary', 
  size = 'medium', 
  disabled = false,
  fullWidth = false,
  className = '',
  icon = null,
  loading = false,
  withGlow = false,
  ...props 
}) => {
  return (
    <button 
      className={`ui-button ${type} ${size} ${fullWidth ? 'full-width' : ''} ${withGlow ? 'with-glow' : ''} ${loading ? 'loading' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      <span className="button-content">
        {icon && <span className="button-icon">{icon}</span>}
        {children}
      </span>
      {loading && <span className="button-loader"></span>}
      {withGlow && <span className="button-glow"></span>}
    </button>
  );
};

export default Button;